import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import _ from 'lodash'
import { Typography } from '@mui/material'
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation'
import { Column, Row } from 'src/components/Layout/Styled'
import { convertFormatTime } from 'src/utils/lib'
import Detail from './Detail'
import { COURSE_TYPE_TH } from 'src/constants/eLearning'

const Summary = () => {
  const data = useSelector((state) => state.eLearningEnroll.data, shallowEqual)
  const classroom = _.get(data, 'classroom', '-')
  const courseType = COURSE_TYPE_TH[_.get(data, 'courseType', '')] || '-'
  const time = convertFormatTime({
    hours: _.get(data, 'totalHour', 0),
    minutes: _.get(data, 'totalMinute', 0),
  })

  return (
    <Column sx={{ background: '#FAFAFA', mb: 2, p: 3, rowGap: 2 }}>
      <Row>
        <InsertInvitationIcon sx={{ mr: 1, fontSzie: 24, color: '#00008F' }} />
        <Typography variant="h6" color="primary.main">
          {`รายละเอียดเข้าอบรม`}
        </Typography>
      </Row>
      <Column sx={{ background: '#FFFFFF', p: 2, rowGap: '12px' }}>
        <Detail label={'วันที่อบรม'} value={data?.eLearningCourseDate || '-'} />
        <Detail label={'ระยะเวลาของหลักสูตร'} value={time || '-'} />
        <Detail label={'รูปแบบการสอน'} value={classroom} />
        <Detail label={'กลุ่มหลักสูตร'} value={courseType} />
      </Column>
    </Column>
  )
}

export default Summary
